<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">
            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-12 vincent_reservation_block ">
                    <div class="relative-bottom">
                        <h3>{{"be_always_with_us" | translate}}</h3>
                        <h1>{{"singing_in" | translate}}</h1>
                        <img src="assets/imgs/separator_dark.png" alt="">
                        <div class="vincent_form_block">
                            <img src="assets/imgs/loading2.gif" style="width: 40px;" *ngIf="loading == true">
                        </div>
                        <div class="alert alert-danger cus" role="alert" *ngIf="errorMessage !== '' ">
                            {{errorMessage}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>